import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";

function PortionOthersCommentary({ collectionName, portionName }) {
  const userId = localStorage.getItem("user_id");
  const [commentaries, setCommentaries] = useState([]);
  const [users, setUsers] = useState([]);
  const [showCommentary, setShowCommentary] = useState(false);

  useEffect(() => {
    if (!showCommentary || !portionName) return;

    const fetchData = async () => {
      const [commSnap, usersSnap] = await Promise.all([
        getDocs(
          query(
            collection(db, collectionName),
            where("portion", "==", portionName)
          )
        ),
        getDocs(collection(db, "users")),
      ]);
      setCommentaries(commSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      setUsers(usersSnap.docs.map(d => ({ id: d.id, ...d.data() })));
    };

    fetchData();
  }, [collectionName, portionName, showCommentary]);

  const othersCommentaries = commentaries.filter(c => c.user_id !== userId);

  return (
    <div>
      {showCommentary ? (
        <div>
          <button id="bigbutton" onClick={() => setShowCommentary(false)}>
            Hide What Others Are Saying
          </button>
          {othersCommentaries.length === 0 && (
            <p className="commentary-text">No one else has commented on this portion yet.</p>
          )}
          {othersCommentaries.map(c => {
            const user = users.find(u => u.id === c.user_id);
            if (!user) return null;
            return (
              <div key={c.id} className="roundedbox">
                <div className="commentary-text">
                  {user.profile_pic_url && (
                    <div>
                      <img
                        id="smallprofilepic"
                        src={user.profile_pic_url}
                        alt={`${user.first_name} ${user.last_name}'s profile`}
                      />
                      <br />
                    </div>
                  )}
                  <b>{user.first_name} {user.last_name} wrote:</b>
                </div>
                <p className="commentary-text">{c.commentary}</p>
              </div>
            );
          })}
        </div>
      ) : (
        <button id="bigbutton" onClick={() => setShowCommentary(true)}>
          See What Others Are Saying
        </button>
      )}
      <br /><br /><br />
    </div>
  );
}

export default PortionOthersCommentary;
